import React from "react";
import { createUseStyles } from "react-jss";
import jssVariables from "../../jss_setup";
import { InlineIcon } from "@iconify/react";

const externallyHostedPaymentStyles = createUseStyles({
  ExternallyHostedPayment: {
    display: "grid",
    alignContent: "center",
    justifyContent: "center",
    placeItems: "center",
    textAlign: "center",
    height: "100%",
    minHeight: "30vh",
  },
  loaderIcon: { fontSize: "xxx-large" },
  label: { color: jssVariables.colors.text.dark },
});
const ExternallyHostedPayment = () => {
  const classes = externallyHostedPaymentStyles();

  return (
    <div className={classes.ExternallyHostedPayment}>
      <InlineIcon icon="eos-icons:loading" className={classes.loaderIcon} />
      <h4 className={classes.label}>
        Please wait while we are initiating your payment process.
      </h4>
    </div>
  );
};
export default ExternallyHostedPayment;
